import React from 'react';
import { ErrorBoundary } from '../../utils/errorBoundary';
import LocationCard from './LocationCard';
import { locations } from '../../data/locations';
import { MapPin } from 'lucide-react';

export default function LocationList() {
  return (
    <div className="space-y-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        <div className="bg-gray-800 rounded-lg p-6">
          <div className="mb-4">
            <p className="text-purple-500 font-semibold mb-2">Coming Soon!</p>
            <h3 className="text-lg md:text-xl font-semibold text-white mb-1">DiversiCoin Downtown BTM</h3>
            <p className="text-sm md:text-base text-gray-400">7-Eleven Downtown</p>
          </div>
          <div className="space-y-3 text-gray-300">
            <p>Buy & Sell</p>
            <p>7:00 AM - 9:00 PM</p>
            <p>Limits: $20 - $5,000</p>
            <p className="text-sm text-gray-400">BTM Model: Model V</p>
          </div>
        </div>

        <div className="bg-gray-800 rounded-lg p-6">
          <div className="mb-4">
            <p className="text-purple-500 font-semibold mb-2">Coming Soon!</p>
            <h3 className="text-lg md:text-xl font-semibold text-white mb-1">Uptown Plaza BTM</h3>
            <p className="text-sm md:text-base text-gray-400">QuikTrip Uptown</p>
          </div>
          <div className="space-y-3 text-gray-300">
            <p>Buy</p>
            <p>7:00 AM - 5:00 PM</p>
            <p>Limits: $20 - $2,000</p>
            <p className="text-sm text-gray-400">BTM Model: Mini Model</p>
          </div>
        </div>

        <div className="bg-gray-800 rounded-lg p-6">
          <div className="mb-4">
            <p className="text-purple-500 font-semibold mb-2">Coming Soon!</p>
            <h3 className="text-lg md:text-xl font-semibold text-white mb-1">Deep Ellum BTM</h3>
            <p className="text-sm md:text-base text-gray-400">Deep Ellum Convenience Store</p>
          </div>
          <div className="space-y-3 text-gray-300">
            <p>Buy & Sell</p>
            <p>9:00 AM - 8:00 PM</p>
            <p>Limits: $20 - $8,000</p>
            <p className="text-sm text-gray-400">BTM Model: Universal Model</p>
          </div>
        </div>
      </div>

      {/* Future Locations Section */}
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-8 text-center">
        <h3 className="text-2xl font-bold text-white mb-4">More Locations Coming Soon</h3>
        <p className="text-gray-300 mb-6">
          We're expanding our BTM network across Texas. Check back regularly for new locations.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-3xl mx-auto">
          <div className="flex items-center justify-center space-x-3 bg-gray-700/50 rounded-lg p-4">
            <MapPin className="w-6 h-6 text-purple-500" />
            <span className="text-gray-300">Dallas–Fort Worth</span>
          </div>
          <div className="flex items-center justify-center space-x-3 bg-gray-700/50 rounded-lg p-4">
            <MapPin className="w-6 h-6 text-purple-500" />
            <span className="text-gray-300">Houston</span>
          </div>
          <div className="flex items-center justify-center space-x-3 bg-gray-700/50 rounded-lg p-4">
            <MapPin className="w-6 h-6 text-purple-500" />
            <span className="text-gray-300">Austin</span>
          </div>
        </div>
      </div>
    </div>
  );
}